const r = (t) => t ? /^(http|\.?\/|#)/i.test(t) ? t : `//${t}` : "", i = (t = "") => /^(http|\/\/)/i.test(t), s = ({ text: t, url: n }) => {
  const e = r(n);
  return {
    value: {
      href: e,
      target: i(e) ? "_blank" : void 0,
      text: t
    }
  };
};
export {
  s as c,
  r as g,
  i
};
